import '@/assets/styles/js/swiper';

import { Swiper as DefaultSwiper, SwiperSlide } from 'swiper/react';
import { A11y, Pagination } from 'swiper/modules';
import { Children, forwardRef } from 'react';
import { cn } from '@/lib/utils';

const BaseSwiper = forwardRef(({ children, id, ...props }, ref) => {
  const modules = [Pagination, A11y, ...(props?.modules ?? [])].filter(Boolean);

  return (
    <div className={cn('relative w-100 isolate', props.className)}>
      <DefaultSwiper {...props} modules={modules} id={id} ref={ref}>
        {Children.map(children, (child, index) => (
          <SwiperSlide key={index} className={`!h-auto ${id}-slide`}>
            {child}
          </SwiperSlide>
        ))}
      </DefaultSwiper>
    </div>
  );
});
BaseSwiper.displayName = 'BaseSwiper';

export default BaseSwiper;
